import {stringUStoISO, dateToUsString} from '../../../../date-converter';
import {addCommasToNumber} from "../../../../utils";


export const buildRentRollRow = function (tab, reimbTab) {
    return {
        valueCells: [{ // % of Sq Ft - 0
            editable: false,
            nameClasses: 'font-gotham font-size-10',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = tabs[tab].tables['detailed-information'].rows[rowIdentifier].valueCells[0].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // Start - 1
            editable: false,
            nameClasses: 'font-gotham font-size-10',
            getComputedValue(tabs, rowIdentifier) {
                const value = tabs[tab].tables['detailed-information'].rows[rowIdentifier].valueCells[1].value;
                const displayValue = !value ? '-' : `${value.toLocaleString()}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // End - 2
            editable: false,
            nameClasses: 'font-gotham font-size-10',
            getComputedValue(tabs, rowIdentifier) {
                const value = tabs[tab].tables['detailed-information'].rows[rowIdentifier].valueCells[2].value;
                const displayValue = !value ? '-' : `${value.toLocaleString()}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // Current Annual Rent - 3
            editable: false,
            nameClasses: 'font-gotham font-size-10',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = tabs[tab].tables['detailed-information'].rows[rowIdentifier].valueCells[4].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // PSF - 4
            editable: false,
            nameClasses: 'font-gotham font-size-10',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                let value;
                if (tab === 'current-rr-tab')
                    value = tabs[tab].tables['detailed-information'].rows[rowIdentifier].valueCells[5].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                else
                    value = tabs[tab].tables['detailed-information'].rows[rowIdentifier].valueCells[5].value;
                const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // Escalation Date - 5
            editable: false,
            nameClasses: 'font-gotham font-size-10',
            getComputedValue(tabs, rowIdentifier) {
                const value = tabs['current-rr-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[10].value;                
                const displayValue = !value ? '-' : `${value.toLocaleString()}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // Escalation Amount - 6
            editable: false,
            nameClasses: 'font-gotham font-size-10',
            getComputedValue(tabs, rowIdentifier) {
                const escalationDate = tabs['current-rr-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[10].value; 
                let value = (parseFloat(tabs['current-rr-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[11].value) || 0);
                value = value * 12
                const displayValue = escalationDate? !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})}` : '-';
                return {internalValue: value, displayValue: displayValue};
            },
        },
        { // Escalation PSF - 6
            editable: false,
            nameClasses: 'font-gotham font-size-10',
            getComputedValue(tabs, rowIdentifier) {
                const escalationDate = tabs['current-rr-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[10].value; 
                const sqFt = parseInt(tabs[tab].tables['general-information'].rows[rowIdentifier].valueCells[2].value);
                let rent = (parseFloat(tabs['current-rr-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[11].value) || 0);
                rent = rent * 12
                const value = parseFloat(rent / sqFt);
                const displayValue = escalationDate? !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '-';
                return {internalValue: value, displayValue: displayValue};
            },
        },
        { // Options - 7
            editable: false,
            nameClasses: 'font-gotham font-size-10',
            getComputedValue(tabs, rowIdentifier) {
                const value = tabs['current-rr-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[15].value;
                const displayValue = !value ? '-' : `${value.toLocaleString()}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { 
            editable: false,
            nameClasses: 'font-gotham font-size-10',
            getComputedValue(tabs, rowIdentifier) {
                const value = tabs['current-rr-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[16].value;
                const displayValue = !value ? '-' : !isNaN(value) ? `$${addCommasToNumber(value).toLocaleString()}` : value;
                return {internalValue: value, displayValue: displayValue};
            },
        },   { // Lease Type - 8
            unit: '',
            type: 'number',
            nameClasses: 'font-gotham font-size-10',
            editable: false,
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = tabs[reimbTab].tables['detailed-information'].rows[rowIdentifier].valueCells[1].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const displayValue = !value ? '-' : value;
                return {internalValue: value, displayValue: displayValue};
            },
        }]
    }
};

export const rentRoll = {
    hasNamesColumn: false,
    rows: {},
};
